// ── polyGateBannerStore — visibility flag for the trader-role-gate banner ──
//
// One-time dismissable notice shown to a trader-role user whose browser had
// stale personal-key Polymarket credentials when the role gate landed. The
// central mount in AuthedShell wipes those credentials and flips this flag
// on; the user dismisses by clicking the X.
//
// "Dismissed" is persisted in localStorage under a channel-namespaced key so
// the banner doesn't re-appear after a reload. The store itself is
// session-local — it just tracks "render or not" for the current page.

import { create } from 'zustand';
import { storageKey } from '../lib/infra/storage';

export const POLY_GATE_BANNER_DISMISSED_KEY = storageKey(
  'poly_trader_gate_notified_v1',
);

interface PolyGateBannerState {
  showCleared: boolean;
  setShowCleared: (v: boolean) => void;
}

export const usePolyGateBannerStore = create<PolyGateBannerState>((set) => ({
  showCleared: false,
  setShowCleared: (showCleared) => set({ showCleared }),
}));

/** True if the user has previously dismissed the banner this browser. */
export function isPolyGateBannerDismissed(): boolean {
  try {
    return localStorage.getItem(POLY_GATE_BANNER_DISMISSED_KEY) === 'true';
  } catch {
    return false;
  }
}

/** Persist the dismissal so future loads don't re-show the banner. */
export function markPolyGateBannerDismissed(): void {
  try {
    localStorage.setItem(POLY_GATE_BANNER_DISMISSED_KEY, 'true');
  } catch {
    // localStorage unavailable (private mode, etc.) — banner reappears
    // on next load. Acceptable.
  }
}
